const digits = value => String(value ?? "").replace(/\D/g, "");

// Search equivalence only, never an ownership/history/dispatch identity.
// The Brazilian ninth digit and country/area code do not change the last eight.
export function matchesCrmPhoneSearch(phone, query) {
  const number = digits(phone);
  const search = digits(query);
  if (!number || !search) return false;
  return number.includes(search)
    || (number.length >= 8 && search.length >= 8 && number.slice(-8) === search.slice(-8));
}
